import React, { useRef, useCallback } from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { removeUnderScore } from "../../../../helper/Helper";
import styles from "./Style.module.css";
import { Typography } from "@mui/material";
import NoDataFound from "../../../ProgramDashboard/component/NoDataFound/NoDataFound";
import { FileDownloadOutlined } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const CustomRadarChart = ({
  graphData,
  isExpand,
  title = "",
  isImgDownload,
  onExpand,
  isExport,
  downloadTitle,
  handleExport,
}) => {
  const chartRef = useRef();

  const handleDownload = useCallback(() => {
    if (!chartRef.current) return;

    const svg = chartRef.current.container?.firstChild;
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      const paddingTop = 40;
      const canvas = document.createElement("canvas");
      canvas.width = svg.clientWidth || 1200;
      canvas.height = (svg.clientHeight || 600) + paddingTop;
      const ctx = canvas.getContext("2d");

      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#636578";
      ctx.font = "bold 16px Arial";
      ctx.textAlign = "left";
      ctx.textBaseline = "top";
      ctx.fillText(title || "Radar Chart", 10, 10);

      ctx.drawImage(img, 0, paddingTop);

      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = pngUrl;
      a.download = `${title || "Engagement"}.png`;
      a.click();
    };
    img.src = url;
  }, [title]);

  return (
    <div className={styles.graphCont}>
      <div className={styles.dFlex}>
        <div className={styles.dFlex}>
          <Typography variant={"h5"} className={"heading"}>
            {title}
          </Typography>
          {isExpand && (
            <OpenInNewIcon
              onClick={onExpand}
              color="primary"
              size="small"
              className={styles.expandIcon}
            />
          )}
          {isImgDownload && (
            <FileDownloadOutlined
              onClick={handleDownload}
              color="primary"
              fontSize="small"
              className={styles.downloadIcon}
            />
          )}
        </div>
        <div>
          {isExport && (
            <div className={styles.dFlex2}>
              <Typography variant="h5" className="heading">
                {downloadTitle}
              </Typography>
              <FileDownloadOutlined
                onClick={handleExport}
                color="primary"
                size="small"
                className={styles.expandIcon}
              />
            </div>
          )}
        </div>
      </div>
      {graphData?.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart ref={chartRef} data={graphData}>
            <PolarGrid />
            <PolarAngleAxis
              dataKey="type"
              tick={({ payload, x, y, textAnchor }) => {
                const label = removeUnderScore(payload.value);
                const yOffset = 6;
                return (
                  <text
                    x={x}
                    y={payload.coordinate == "-90" ? y + yOffset : y}
                    textAnchor={textAnchor}
                    dominantBaseline="central"
                    fill="#666"
                    fontSize={12}
                  >
                    {label}
                  </text>
                );
              }}
            />
            <PolarRadiusAxis angle={30} domain={[0, 50]} tickCount={7} />
            <Radar
              name="Engagement"
              dataKey="count"
              stroke="#0088FE"
              fill="#0088FE"
              fillOpacity={0.3}
            />
            <Tooltip />
          </RadarChart>
        </ResponsiveContainer>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default CustomRadarChart;
